import axios from 'axios';

export const fetchStores = (projectId, params) => axios.get(`/projects/${projectId}/stores`, { params });
export const fetchStore = (projectId, storeId) => axios.get(`/projects/${projectId}/stores/${storeId}`);
export const fetchStoreVisits = (projectId, storeId, params = {}) => axios.get(`/projects/${projectId}/stores/${storeId}/visits`, { params });
export const fetchStoresWithVisits = (projectId, params) => axios.get(`/projects/${projectId}/store_aggregations`, { params });
export const exportStoresWithVisits = (projectId, params) => axios.post(`/projects/${projectId}/store_aggregations/export`, params);
export const exportStoresWithoutVisits = (projectId, params) => axios.post(`/projects/${projectId}/stores/all_export`, params, {
  headers: {
    'Content-Type': 'application/json'
  }
});
export const fetchStoreKpiAggregations = (projectId, params) => axios.get(`/projects/${projectId}/store_aggregations/kpis`, { params });
